<template>
  <div 
    class="tabs"
    ref="tabRef"
    v-loading="loading">
    <a 
      v-for="(item, index) in tabs"
      :key="index"
      :class="['item', {'active': active == index}]"
      @click="tabClick(index)">
      {{item.name}}
      <span v-show="item.num">({{item.num}})</span>
    </a>
    <div class="active-bg" :style="bgStyle"></div>
  </div>
</template>

<script>
export default {
  name: 'default',
  data () {
    return {
      active: null,
      bgStyle: {}
    }
  },
  props: {
    tabs: {
      type: Array,
      required: false,
      default: () => []
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  watch: {
    tabs: {
      handler(val){
        val && 
        val.length && 
        this.active == null && 
        this.$nextTick(() => this.tabClick(0));
      },
      immediate: true
    }
  },
  methods: {
    tabClick(index){
      if(this.active == index) return;
      this.active = index;
      let tab = this.tabs[index];
      let item = this.$refs.tabRef.getElementsByClassName('item')[index];
      this.bgStyle = {
        top: `${item.offsetTop}px`,
        left: `${item.offsetLeft}px`,
        width: `${item.clientWidth}px`
      }
      this.$emit('active', tab);
    }
  }
}
</script>

<style lang="scss" scoped>
.tabs{
  position: relative;
  min-height: 40px;

  a{
    display: inline-block;
    line-height: 40px;
    padding: 0 25px;
    color: $text2;
    font-size: 14px;
    font-weight: normal;
    position: relative;
    z-index: 1;
    transition: color .5s ease-out;
    user-select: none;

    span{
      color: $text-red;
      transition: color .5s ease-out;
      font-size: 13px;
    }

    &:hover{
      color: $text1;
    }

    &.active{
      color: #fff;
      font-weight: bold;

      span{
        color: #fff;
      }
    }
  }

  .active-bg{
    height: 40px;
    width: 0px;
    background-color: $theme-color;
    z-index: 0;
    transition: .28s ease-out;

    position: absolute;
    left: 0;
    top: 0;
  }

  >>> .el-loading-spinner{
    transform: scale(.7);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Tabs.vue